import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

interface ReplayLevelDialogProps {
  level: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ReplayLevelDialog({ level, onCancel, onConfirm }: ReplayLevelDialogProps) {
  const { t } = useTranslation();

  return createPortal(
    <div className="battle-confirm" role="presentation">
      <section
        className="battle-confirm__card replay-confirm__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="replay-title"
        aria-describedby="replay-description"
      >
        <div className="battle-confirm__icon replay-confirm__icon" aria-hidden="true">◆</div>
        <h2 id="replay-title">{t("campaignReplayTitle", { level })}</h2>
        <p id="replay-description">{t("campaignReplayWarning")}</p>
        <div className="battle-confirm__actions">
          <button autoFocus type="button" onClick={onCancel}>{t("campaignReplayCancel")}</button>
          <button className="replay-confirm__accept" type="button" onClick={onConfirm}>
            {t("campaignReplayConfirm")}
          </button>
        </div>
      </section>
    </div>,
    document.body
  );
}
